import React from 'react';
import './VisitorCounter.css';
import { FaUsers } from 'react-icons/fa';

const VisitorCounter = () => {
    return (
        <section className="visitor-counter">
            <div className="visitor-container">
                <div className="visitor-content">
                    <div className="visitor-icon">
                        <FaUsers />
                    </div>
                    <div className="visitor-stats">
                        <h3 className="visitor-title">Users Served So Far</h3>
                        <div className="counter-wrapper">
                            <span className="counter">50,000+</span>
                            <span className="counter-label">visitors</span>
                        </div>
                    </div>
                </div>
                <div className="visitor-decoration">
                    <div className="pulse-circle"></div>
                </div>
            </div>
        </section>
    );
};

export default VisitorCounter; 